var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Ingredients")]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('ul',{staticClass:"list-group list-group-flush"},_vm._l((_vm.ingredients),function(ingredient){return _c('li',{key:ingredient,staticClass:"list-group-item",domProps:{"innerHTML":_vm._s(ingredient)}})}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }